import { light_black } from "../../StyleHelpers";
import TopAppbar from "../../components/TopAppBar";
import styled from "styled-components/native";
import backIcon from "../../assets/TopNavBarIcon/icon_nav_back.svg";
import closeIcon from "../../assets/TopNavBarIcon/icon_nav_close.svg";
import ImgProgressBar from "./ImgProgressBar";

const StyledContainer = styled.View`
	background-color: ${light_black};
	height: 100vh;
`;

const StyledOptionContainer = styled.View`
	top: 180px;
	height: 60vh;
	margin-left: 14%;
	margin-right: 14%;
	gap: 10px;
`;

const ButtonContainer = styled.View`
	flex-direction: row;
	width: 71.8%;
	position: absolute;
	bottom: 15%;
	margin: 0 14.1% 0 14.1%;
	height: 72px;
	border-radius: 16px;
	overflow: hidden;
`;

const ScreenSelectionContainer = styled.View<any>`
	margin-bottom: 44px;
	height: 60vh;
	font-size: 25px;
	gap: 24px;
`;

const HalfDeviceButtonContainer = styled.View`
	height: 30vh;
	border-radius: 16px;
	overflow: hidden;
	flex: 1;
`;

const FlexDeviceButtonContainer = styled.View`
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	gap: 24px;
`;

const ScreenSelectionLoader = () => {
	return (
		//@ts-ignore
		<StyledContainer>
			<TopAppbar leftIcon={closeIcon} leftIconWidth={92} leftTitleIcon={backIcon} screenTitle={""} />
			{/* @ts-ignore */}
			<StyledOptionContainer>
				{/* @ts-ignore */}
				<ScreenSelectionContainer>
					{/* @ts-ignore */}
					<HalfDeviceButtonContainer>
						<ImgProgressBar />
					</HalfDeviceButtonContainer>
					{/* @ts-ignore */}
					<FlexDeviceButtonContainer>
						{/* @ts-ignore */}
						<HalfDeviceButtonContainer>
							<ImgProgressBar />
						</HalfDeviceButtonContainer>
						{/* @ts-ignore */}
						<HalfDeviceButtonContainer>
							<ImgProgressBar />
						</HalfDeviceButtonContainer>
					</FlexDeviceButtonContainer>
				</ScreenSelectionContainer>
			</StyledOptionContainer>
			{/* @ts-ignore */}
			<ButtonContainer>
				<ImgProgressBar />
			</ButtonContainer>
		</StyledContainer>
	);
};

export default ScreenSelectionLoader;
